import ReactDOMServer from "react-dom/server";
import { EcpPopupContainer } from "./popupTableHelper";
import { filterIndicator, showDigitsIndicValue } from "../../helper";
import { EcpIndicatorsApi, ParameterApi, EventsPluieApi } from "../../api";
import { formatDate } from "../view/detailsHelper";
import React from "react";
import { isStepMode } from "../view/ecpDetailHelper";

export const deverssementPopup = async (feature: any) => {
  let attributes,
    content = document.createElement('div');
  attributes = feature.graphic.attributes;
  const stepMode = isStepMode();
  return stepMode
    ? await getStepPopupContent(attributes, content)
    : await getDeverssementInfoFirstPage(attributes, content);
}

export const getIndicatorValue = (collectionPool: any, indicatorKey: string) => {
  const indicator = filterIndicator(collectionPool, indicatorKey);
  return showDigitsIndicValue(indicator);
};

export const getIndicatorForFirstPage = async (pAttributes: any, pMode: 'pr' | 'step' = 'pr') => {
  const popupHelperResponse = {
    vecpi: 'NR', // Valeur pour VECPI
    vecpc: 'NR', // Valeur pour VECPc
    veus: 'NR', // Valeur pour VEUs
    vecpipercent: 'NR', // Pourcentage de VECPI par rapport à VTOT
    vecpcpercent: 'NR', // Pourcentage de VECPc par rapport à VTOT
    veuspercent: 'NR', // Pourcentage de VEUs par rapport à VTOT
    vecpcsurveus: 'NR', // Pourcentage de VECPc par rapport à VEUs
    vecpisurveus: 'NR', // Pourcentage de VECPI par rapport à VEUs
  };
  let idPov = 'NR';
  const categoriesOnly = pMode === 'step'
    ? true  // STEP layer 203 does not use Color gating - always fetch indicators
    : pAttributes.Color !== 'NOIR' && pAttributes.Color !== 'GRIS';

  try {
    const getIndicatorRequest = pMode === 'step'
      ? EcpIndicatorsApi.getStepIndicator
      : EcpIndicatorsApi.getIndicator;
    const recordDate = pAttributes.RecordDate;
    const hasValidDate = recordDate && recordDate !== 'Null' && recordDate !== 'null';
    const lastDataDate = window.sessionStorage.getItem('ecp_last_data_date');
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const formattedDate = hasValidDate
      ? formatDate(recordDate)
      : lastDataDate
        ? formatDate(lastDataDate) // fallback to most recent table data date ("Données du")
        : yesterday.toISOString().split('T')[0]; // final fallback to yesterday
    const getEcpIndicators = categoriesOnly &&
      await getIndicatorRequest(
        pAttributes.Code,
        formattedDate,
      );
    const povInfo = EventsPluieApi.getInstallPov(pAttributes.Code);
    const [ecpIndicators, povValue] = await Promise.allSettled([getEcpIndicators, povInfo]);   

    if (povValue.status === 'fulfilled' && povValue.value) {
        idPov = povValue.value.data;
    }
    const ecpIndicator = ecpIndicators && ecpIndicators.value.data;
    popupHelperResponse.vecpi = getIndicatorValue(ecpIndicator, 'VECPI');
    popupHelperResponse.vecpc = getIndicatorValue(ecpIndicator, 'VECPC');
    popupHelperResponse.veus = getIndicatorValue(ecpIndicator, 'VEUS');
    popupHelperResponse.vecpcpercent = getIndicatorValue(ecpIndicator, '%VECPC/VTOT');
    popupHelperResponse.vecpipercent = getIndicatorValue(ecpIndicator, '%VECPI/VTOT');
    popupHelperResponse.veuspercent = getIndicatorValue(ecpIndicator, '%VEUS/VTOT');
    popupHelperResponse.vecpcsurveus = getIndicatorValue(ecpIndicator, '%VECPC/VEUS');
    popupHelperResponse.vecpisurveus = getIndicatorValue(ecpIndicator, '%VECPI/VEUS');
  } catch (error) {
    console.log('error measure');
  }

  const tableElements = {
    VECPi: [popupHelperResponse.vecpi, popupHelperResponse.vecpipercent, popupHelperResponse.vecpisurveus],
    VECPc: [popupHelperResponse.vecpc, popupHelperResponse.vecpcpercent, popupHelperResponse.vecpcsurveus],
    VEUs: [popupHelperResponse.veus, popupHelperResponse.veuspercent],
  };

  // Nouvelle section POV pour Page 1
  const iliElements = [
    {
      title: 'POV',
      value: idPov,
    },
  ];

  return { tableElements, iliElements };
}

export const getDeverssementInfoFirstPage = async (
  pAttributes: any,
  pContent: any,
) => {
  const { tableElements, iliElements } = await getIndicatorForFirstPage(pAttributes, 'pr');
  const theadElements = ['', 'm³', '% du VTOT', '% du VEUs'];

  pContent.innerHTML = ReactDOMServer.renderToString(
    <EcpPopupContainer
      title={pAttributes.Description}
      tableElements={tableElements}
      theadElements={theadElements}
      iliElements={iliElements}
      className=''
      module=''
      indicator=''
      dateRemontee={pAttributes.RecordDate}
    />
  );
  return pContent;
}

const getBassinId = async (pAttributes: any) => {
  //Get contactCode
  const contractCode = window.sessionStorage.getItem('contractCode') || '';
  let bassinId = null;
  try {
    const bassinResponse = await ParameterApi.getCollectionPoolPoint(
      pAttributes.Code,
      'AVAL',
      contractCode,
    );
    bassinId = bassinResponse?.data?.collectionPoolId;
  } catch (error) {
    console.log('error pool');
  }
  return bassinId;
}

export const getIndicatorForSecondPage = async (pAttributes: any) => {
  let vecpcbc: any = 'NR';
  let vecpibc: any = 'NR';
  let veusbcVtot: any = 'NR';
  let vecpcbcVtot: any = 'NR';
  let vecpibcVtot: any = 'NR';
  let vecpcbcVeus: any = 'NR';
  let vecpibcVeus: any = 'NR';
  let veusbc: any = 'NR';
  let indicIli, littleSensitiveTreshold, verySensitiveTreshold;
  const categoriesOnly =
    pAttributes.Color !== 'NOIR' && pAttributes.Color !== 'GRIS';
  
  const bassinId = await getBassinId(pAttributes);

  try {
    const collectionPoolResponse =
      categoriesOnly &&
      await EcpIndicatorsApi.getCollectionPoolIndicator(
        bassinId,
        formatDate(pAttributes.RecordDate),
      );
    let collectionPool = collectionPoolResponse && collectionPoolResponse.data;
    vecpcbc = getIndicatorValue(collectionPool, 'VECPC');
    veusbc = getIndicatorValue(collectionPool, 'VEUS');
    vecpibc = getIndicatorValue(collectionPool, 'VECPI');
    vecpcbcVtot = getIndicatorValue(collectionPool, '%VECPC/VTOT');
    vecpibcVtot = getIndicatorValue(collectionPool, '%VECPI/VTOT');
    veusbcVtot = getIndicatorValue(collectionPool, '%VEUS/VTOT');
    vecpcbcVeus = getIndicatorValue(collectionPool, '%VECPC/VEUS');
    vecpibcVeus = getIndicatorValue(collectionPool, '%VECPI/VEUS'); 

    indicIli = filterIndicator(collectionPool, 'ILI');
    littleSensitiveTreshold = filterIndicator(collectionPool, 'ILI_LST');
    verySensitiveTreshold = filterIndicator(collectionPool, 'ILI_VST');
  } catch (error) {
    console.log('error pool');
  }
  return [
    {   
      VECPi: [vecpibc, vecpibcVtot, vecpibcVeus],
      VECPc: [vecpcbc, vecpcbcVtot, vecpcbcVeus],
      VEUs: [veusbc, veusbcVtot],
    },
    { 
      ILI: indicIli !== undefined ? indicIli + ' m³/km/j ' : 'NR',
      SeuilBas:
        littleSensitiveTreshold !== undefined
          ? littleSensitiveTreshold
          : 'NR',
      SeuilHaut:
        verySensitiveTreshold !== undefined
          ? verySensitiveTreshold
          : 'NR',
    }
  ];
}

// STEP popup: single-page, installation-level indicators only (no collection pool page)
export const getStepPopupContent = async (
  pAttributes: any,
  pContent: any,
) => {
  const { tableElements, iliElements } = await getIndicatorForFirstPage(pAttributes, 'step');
  const theadElements = ['', 'm³', '% du VTOT', '% du VEUs'];
  const recordDate = pAttributes.RecordDate !== 'Null' ? pAttributes.RecordDate : undefined;

  pContent.innerHTML = ReactDOMServer.renderToString(
    <EcpPopupContainer
      title={pAttributes.Description}
      tableElements={tableElements}
      theadElements={theadElements}
      iliElements={iliElements}
      className=''
      module=''
      indicator=''
      dateRemontee={recordDate}
    />
  );
  return pContent;
};

export const getDeverssementInfoSecondPage = async (
  pAttributes: any,
  pContent: any,
) => {
  const getPindicator = await getIndicatorForSecondPage(pAttributes);
  const theadElements = ['', 'm³', '% du VTOT', '% du VEUs'];
  const tableElements = getPindicator[0];
  const iliElements = [
    {
      title: 'ILI',
      value: getPindicator[1].ILI !== undefined ? getPindicator[1].ILI : 'NR',
    },
    {
      title: 'Seuil bas',
      value: getPindicator[1].SeuilBas !== undefined ? getPindicator[1].SeuilBas : 'NR',
    },
    {
      title: 'Seuil haut',
      value: getPindicator[1].SeuilHaut !== undefined ? getPindicator[1].SeuilHaut : 'NR',
    },
  ];
  pContent.innerHTML = ReactDOMServer.renderToString(
    <EcpPopupContainer
      title={pAttributes.Description}
      tableElements={tableElements}
      theadElements={theadElements}
      iliElements={iliElements}
      dateRemontee={pAttributes.RecordDate}
    />
  );
  return pContent;
}
